module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/icon_title_lemon-7224af18648d1b74af73305d9b531dba.svg";